import React, {  useState } from 'react';
import moment from 'moment';
import NumericLabel from 'react-pretty-numbers';
import { Paper, Grid, Button, Tooltip, } from '@material-ui/core';
import HistoryIcon from '@material-ui/icons/History';
import ApproveUserModal from './ApproveUserModal';
import AddEditShopVisit from './AddEditShopVisit';
import RejectionDialog from './RejectionDialog';
import AssignUser from './AssignUser';
import ApproveDialog from './ApproveDialog';
import TimelineModal from './TimelineModal';
import { AttachmentsRow, LabelValueCard, } from '../../../shared_elements';
import {  getLocalStorageInfo, permissionCheckFn } from '../../../utils';
import {prettyNumberParamsDB} from "../../../constants";
import { gaTelesisInstance, titanAviInstance } from '../../../shared_elements/components';
export default function ShopVisitCard({item, assemblyType, mntEvents,  changeSVStatus, getResponseBack, rejectionFn, buttonText, eventId, eventName, propsParams,handleTabChange}){
  const [assignUserData,setAssignUserData]=useState({modal:false,moduleName :"shopvisit"})
  const [timetLineModal,setTimetLineModal] = useState(false)
  const [showMore, setShowMore] = useState({});
  const toggleremarks = (id) => {
    setShowMore({
      ...showMore,
      [id]: !showMore[id],
    });
  };
  const userInfo = getLocalStorageInfo()
  const mergedUsers = [...item?.approver_users || []];
  const uniqueUsers = mergedUsers?.filter((user, index, self) =>
  index === self.findIndex(u => u.id === user.id)
);

  return(
    <Paper elevation={3} className="mnt-event-card">
      <Tooltip title="View Status Timeline" arrow>
        <HistoryIcon className={` ${permissionCheckFn( {secondaryKey:'event_history', keyIndex:'U' }) && item.status && [0, 1, 2].includes(item.status.value) ? "timeline-sv" :"timeline-sv-r-10"}`} color="primary"  onClick={() => setTimetLineModal({ modal: true })} />
      </Tooltip>
      <ApproveUserModal userArray={uniqueUsers} item={item} pageTitle="Shopvisit" />
      
      <span className={` ${permissionCheckFn( {secondaryKey:'event_history', keyIndex:'U' }) && item.status && [0, 1, 2].includes(item.status.value) ? "sv-view" :"sv-view-r-10"}`}>   <AddEditShopVisit pageType="View Shop Visit" id={item.id} shopvisitData={item} mntEvents={mntEvents} getResponseBack={getResponseBack} assemblyType={assemblyType} buttonText={buttonText} mode="view" eventId={eventId} eventName={eventName} /></span>
      { permissionCheckFn( {secondaryKey:'event_history', keyIndex:'U' }) && item.status && [0, 1, 2].includes(item.status.value) ?
        <span className="edit-sv">
          <AddEditShopVisit pageType="Add Shop Visit" id={item.id} shopvisitData={item} mntEvents={mntEvents} getResponseBack={getResponseBack} assemblyType={assemblyType} buttonText={buttonText} mode="edit" eventId={eventId} eventName={eventName} />
        </span>:null
      }
      <div className="content-info">
        <div style={{display:'flex',alignItems:"center", }}>  
          {item.status && [0, 1, 2,7].includes(item.status.value) && uniqueUsers?.some(ele=>ele.id==userInfo?.user?.id) ?
          <table>
            <tbody>
              <tr>
                <td>Event {item.status?.value === 2 ? 'In-Review': ' Details Submitted'}</td>
                {(item.status.value === 2 || item.status.value ===7)  && permissionCheckFn( {secondaryKey:'event_history', keyIndex:'APR_REJ' }) ?
                  <>
                    <td>
                        <ApproveDialog item={item} changeStatus={changeSVStatus} approveFn={rejectionFn} pageTitle="shopVisit"   /> 
                    </td>
                    <td><RejectionDialog pageTitle='Shop Visit' item={item} getResponseBack={getResponseBack} changeStatus={changeSVStatus} assemblyType={assemblyType} rejectionFn={rejectionFn}  /></td>
                  </>:null
                }
              </tr>
            </tbody>
          </table>
           :null}  
          {item?.status && [1,5,2,7].includes(item.status.value) &&
            permissionCheckFn({ secondaryKey: 'event_history', keyIndex: 'U' }) &&
            (
              uniqueUsers == null || 
              (Array.isArray(uniqueUsers) &&
                (
                  uniqueUsers.length === 0 || 
                  uniqueUsers?.some(ele => ele.id == userInfo?.user?.id)
                )
              )
            ) ? (
            <>
              {item.status && [1,7,2].includes(item.status.value) && uniqueUsers?.some(ele => ele.id == userInfo?.user?.id) ?  <div className="divider"></div> : null}
              <div style={{ marginRight: "10px" }}>
                <Button
                  color="primary"
                  variant="outlined"
                  size="small"
                  onClick={() => setAssignUserData({ ...assignUserData, modal: true, moduleName: "shopvisit" })}
                >
                  {item?.status?.value === 1 ||item?.status?.value === 2  ? "Send for Review" :  "Send For Approval" }
                </Button>
              </div>
            </>
          ) : null
          }
        </div>
        <Grid container spacing={3} style={{margin: 0}}>
          <LabelValueCard md={3} label='Event Number' value={item.shop_visit_number ? item.shop_visit_number:'--'} />
          <LabelValueCard md={3} label='Event Facility' value={item.shop_visit_facility ? item.shop_visit_facility:'--'} />
          <LabelValueCard md={3} label='Facility Location' value={item.facility_location ? item.facility_location:'--'} />
          <LabelValueCard md={3} label='Event Cost' value={item.cost ?  <NumericLabel params={prettyNumberParamsDB}>{item.cost}</NumericLabel>  :'--'} />
          <LabelValueCard md={3} label= {item?.asset_type == 1 ? 'Event Start Date': 'Shop Visit Start Date'} value={item.shop_visit_start_date ?  moment(item?.shop_visit_start_date).format('MMM DD, YYYY')  :'--'} />
          <LabelValueCard md={3} label= {item?.asset_type == 1 ? 'Event Completion Date': 'Shop Visit Completion Date'} value={item.shop_visit_date ?   moment(item?.shop_visit_date).format('MMM DD, YYYY')  :'--'} />
          {titanAviInstance ?null :<LabelValueCard md={6} label='Event Reason' value={item.removal_reason ? item.removal_reason:'--'} />}
          <LabelValueCard md={6} label={`Event Workscope / Details`} value={item.workscope_details ? item.workscope_details:'--'} />
          <LabelValueCard md={3} label='TSN at Event' value={item.tsn ? item.tsn:'--'} />
          <LabelValueCard md={3} label='CSN at Event' value={item.csn ? item.csn:'--'} />
          <LabelValueCard md={3} label='Status' value={item.status ? item.status.label:'--'} />
          {assemblyType==='engine' && item?.prsv_reserve_account?<LabelValueCard md={3} label='PSRV Reserve Account' value={item?.prsv_reserve_account?.name ? item.prsv_reserve_account?.name:'--'} />:null}
          {assemblyType==='engine' && item?.llp_reserve_account?<LabelValueCard md={3} label='LLP Replacement Reserve Account' value={item?.llp_reserve_account?.name ? item.llp_reserve_account?.name:'--'} />:null}
          { item.status && item.status.label === 'Rejected' ?
            <LabelValueCard md={3} label='Rejection Reason' value={item.reason_for_rejection ? item.reason_for_rejection:'--'} />:null
          }
          <LabelValueCard md={3} label='Claim Validity Period (Days)' value={item?.claim_approval_period ? item.claim_approval_period:'--'} />
          <LabelValueCard md={3} label='Attachments' value={item?.attachments?.length>0 ?<AttachmentsRow attachmentsData={item?.attachments}/>:'--'} />
           {gaTelesisInstance?<LabelValueCard md={8} label={`Remarks`} value={item?.remarks && item?.remarks?.length > 200 ? (
          <div>
            {showMore[item?.id] && showMore[item?.id] ? (
              <span>
                <span dangerouslySetInnerHTML={{ __html: item?.remarks.replace(/\n/g, '<br />') }} />
                <a href='#' style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleremarks(item?.id); }} >
                  less
                </a>
              </span>
            ) : (
              <span>
                <span dangerouslySetInnerHTML={{ __html: item?.remarks.substring(0, 190).replace(/\n/g, '<br />') }} />
                <a href='#' style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleremarks(item?.id); }} >
                  ..more
                </a>
              </span>
            )}
          </div>
        ) : (
          <div>
                {item?.remarks ? <span dangerouslySetInnerHTML={{ __html: item?.remarks.replace(/\n/g, '<br />') }} />:'--'}
          </div>
        )}/>:null}
        </Grid>
        {assignUserData?.modal ? <AssignUser pageTitle="Shopvisit" item={item} assignUserData={assignUserData} getResponseBack={getResponseBack} assetData={item} toggleModalFn={() => setAssignUserData({ modal: false, moduleName: "" })} /> : null}
        {timetLineModal ? <TimelineModal propsParams={propsParams} pageTitle="Shopvisit" assemblyType={assemblyType} item={item} modal={timetLineModal?.modal} toggleModalFn={() => setTimetLineModal({modal:false})} /> : null}
      </div>
    </Paper>
  )
}
